import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

import SearchParamsGuard from './SearchParamsGuard';

const routes: RouteObject[] = [
  {
    path: 'my-work',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: () => (
          <SearchParamsGuard
            configs={[
              {
                prefix: 'project',
              },
            ]}
          />
        ),
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/myWork/MyWorkPage')),
          },
        ],
      },
    ],
  },
];

export default routes;
